module.exports = __webpack_public_path__ + "static/media/Letter_circulation_18022019.6904e573.pdf";